import * as React from 'react';
import { AttendanceResponseDTO } from '../../../ApiOld/ApiServerVov';
import { Box, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import TimeFromMinutes from '../../Shared/Functions/TimeFromMinutes';
import { Info } from '@mui/icons-material';
import MobileAttendanceDetail from './MobileAttendanceDetail';

export interface IMobileAttendanceWorkTabProps {
    data: AttendanceResponseDTO[];
}

export default function MobileAttendanceWorkTab(props: IMobileAttendanceWorkTabProps) {
    const { data } = props;
    const { t } = useTranslation();
    const [selected, setSelected] = React.useState<AttendanceResponseDTO>();

    const getHours = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => (p.minutes ?? 0) > 0).forEach((item) => {
            minutes += item.minutes ?? 0;
        });
        return Math.trunc(minutes / 60).toString();
    }

    const getMinutes = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => ((p.minutes ?? 0) > 0)).forEach((item) => {
            minutes += item.minutes ?? 0;
        });
        const result = minutes % 60;
        return result.toString().padStart(2, '0');
    }

    return (
        <Grid container sx={{
            flex: 1, p: 0, height: 'calc(100vh - 245px)'
        }}>
            < Grid item xs={12} >
                <Box sx={{ background: 'white', p: 0, boxShadow: 3, borderRadius: '10px', width: '100%' }} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <div />
                    <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                        <Typography fontWeight={'bold'}>{t('diary.hoursHeadings')}</Typography>
                        <Stack direction={'row'}>
                            <Typography variant='h3' color={"#FFC600"}>{getHours(data)}{':'}{getMinutes(data)}</Typography>
                            <Typography variant='h6' color={"#FFC600"} marginTop={'22px'}>{'h'}</Typography>
                        </Stack>
                    </Stack>
                    <div />
                </Box>
                <Box sx={{ background: 'white', p: 1, boxShadow: 3, borderRadius: '10px', width: '100%', marginTop: '16px', marginBottom: '8px' }} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 300, border: 'none' }} aria-label="simple table">
                            <TableHead sx={{ borderBottom: '1px solid lightgray' }}>
                                <TableRow>
                                    <TableCell sx={{ border: 'none' }}>{t('Date')}</TableCell>
                                    <TableCell sx={{ border: 'none' }} align="right">{t('log.hours')}</TableCell>
                                    <TableCell sx={{ border: 'none' }} align="right">{t('deposit')}</TableCell>
                                    <TableCell sx={{ border: 'none' }} align="right"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody /* sx={{ border: '1px solid lightgray' }} */>
                                {data.filter(p => ((p.minutes ?? 0) > 0 || (p.deposit ?? 0) > 0)).map((row) => (
                                    <TableRow
                                        key={row.date?.toString()}
                                        onClick={() => { setSelected(row); }}
                                    >
                                        <TableCell sx={{ border: 'none', borderBottom: '1px solid lightgray', width: '150px' }} component="th" scope="row">
                                            {row.date?.toLocaleDateString(undefined, {
                                                weekday: 'short',
                                                /* year: 'numeric', */
                                                month: '2-digit',
                                                day: '2-digit',
                                            })}
                                        </TableCell>
                                        <TableCell sx={{ border: 'none', borderBottom: '1px solid lightgray', width: '100px' }} align="right" >{TimeFromMinutes(row.minutes ?? 0)}</TableCell>
                                        <TableCell sx={{ border: 'none', borderBottom: '1px solid lightgray', width: '110px' }} align="right">{row.deposit}</TableCell>
                                        <TableCell sx={{ border: 'none', borderBottom: '1px solid lightgray', maxWidth: '50px' }} align="left">{row.isAdminEdited ? <Info fontSize='small' color='primary' /> : <div />}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                {selected && <MobileAttendanceDetail data={selected} open={!!selected} onClose={() => { setSelected(undefined); }} />}
            </Grid>
        </ Grid>);
}
